module.exports = __webpack_public_path__ + "fonts/554c058f7871d281da926cd8758f0b98.svg";